// Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.
// svgs/regular/xmark.svg: path and width byte-identical (components/icons, Phase 5).
export default function RegularXmarkIcon({className}: {className?: string}) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      data-page-icon="regular/xmark"
      fill="currentColor"
      focusable="false"
      height="1em"
      overflow="visible"
      viewBox="0 0 384 512"
      width="0.75em"
    >
      <path d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z" />
    </svg>
  )
}
